import { Box, Container, Grid, Typography, Button } from "@material-ui/core";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthContext } from "../auth/AuthContext";
import { httpGet, httpPost } from "../lib/apiClients";
import { AxiosResponse } from "axios";
import RatingStars from "../components/RatingStars";
import RatingTicket from "../components/RatingTicket";
import LoaderComponent from "../components/LoaderComponent";
import ButtonLoader from "../components/ButtonLoader";
import { ThemeContext } from "../context/ThemeContext";
import SectionHeader from "../components/SectionHeader";
import { Environment } from "../utils/environments";
import { setAnalyticsData } from "../utils/firebaseLog";
import ConcernTextArea from "../components/ConcernTextArea";
import ErrorModal from "../components/ToastModal";
import RatingModal from "../components/RatingModal";
export default function Ratings() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { getPurchaseList } = useContext(ThemeContext);
  const [purchaseList, setPurchaseList] = getPurchaseList;
  const { currentUser } = useContext(AuthContext);
  const [ticketData, setTicketData] = useState<any>();
  const [ratedData, setRatedData] = useState<any>([
    {
      score: 5,
      title: "親しみやすさ",
    },
    {
      score: 5,
      title: "スムーズな進行",
    },
    {
      score: 5,
      title: "問題解決力",
    },
    {
      score: 5,
      title: "丁寧な説明",
    },
  ]);
  const [firstRatedData, setFirstRatedData] = useState<any>([]);
  const [tipData, setTipData] = useState<any>();
  const [activeButton, setActiveButton] = useState<any>("no-tip");
  const [loading, setLoading] = useState<boolean>(false);
  const [ratingComment, setRatingComment] = useState("");
  const [ratingTextError, setRatingTextError] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [error, setError] = useState<boolean | string>(false);
  const [showAllRatings, setShowAllRatings] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [modalData, setModalData] = useState<any | undefined>(undefined);
  const navigate = useNavigate();
  const ticketNumber = searchParams.get("ticketNumber")
    ? searchParams.get("ticketNumber")
    : undefined;
  if (!ticketNumber) {
    navigate(`/error?code=404`);
  }
  useEffect(() => {
    document.title = "評価とチップ | じぶん専用IT相談室";
    if (currentUser === undefined) {
      return;
    }
    if (!currentUser) {
      navigate("/login", {
        state: {
          from: window.location.pathname,
          search: window.location.search,
        },
      });
    } else {
      getTipData();
      getRatingData();
    }
  }, [currentUser]);
  const getTipData = async () => {
    try {
      await httpGet({
        pathName: "nowonsale-products",
        queryParams: {
          productType: "TIP",
        },
      }).then((response: AxiosResponse<any>) => {
        var data = response.data;
        if (Environment.getBuildType() != "prod") {
          console.log(data);
        }
        setTipData(data);
      });
    } catch (error) {
      if (Environment.getBuildType() != "prod") {
        console.log(error);
      }
      navigate(`/error?code=${error.response?.status}`);
    }
  };
  const getRatingData = async () => {
    try {
      await httpGet({
        pathName: "ticket-data",
        queryParams: {
          ticketNumber: ticketNumber,
          action: "RATING",
        },
      }).then((response: AxiosResponse<any>) => {
        var data = response.data;
        if (Environment.getBuildType() != "prod") {
          console.log(data);
        }
        setTicketData(data);
      });
    } catch (error) {
      if (Environment.getBuildType() != "prod") {
        console.log(error);
      }
      if (error.response.status >= 400 && error.response.status <= 499) {
        navigate(`/error?code=400`);
      } else {
        navigate(`/error?code=${error.response?.status}`);
      }
    }
  };
  function getFiveStarRating(score: number, title: string, type: string) {
    if (loading) {
      return;
    }
    if (type == "first") {
      setShowAllRatings(true);
      setFirstRatedData({
        score,
        title,
      });
    } else {
      var isAlreadyInArray: boolean = false;
      setRatedData((oldData: any) => {
        oldData.map((data: any) => {
          if (data?.title == title) {
            data.score = score;
            isAlreadyInArray = true;
            return;
          }
        });
        if (!isAlreadyInArray) {
          return [...oldData, { score, title }];
        } else {
          return [...oldData];
        }
      });
    }
  }
  const ratingList = [
    {
      title: "親しみやすさ",
      important: false,
    },
    {
      title: "スムーズな進行",
      important: false,
    },
    {
      title: "問題解決力",
      important: false,
    },
    {
      title: "丁寧な説明",
      important: false,
    },
  ];
  function handleTip(id) {
    setActiveButton(id);
  }
  function handleRatingSubmit() {
    let totalScore = 0;
    for (let i = 0; i < ratedData.length; i++) {
      totalScore += ratedData[i].score;
    }
    if (ratingComment.length > 500) {
      setLoading(false);
      setRatingTextError(true);
      setErrorModal(true);
      setError("500文字以内で入力してください。");
      return;
    }
    var params = {
      ticketNumber: ticketData?.ticketNumber,
      memberTotalScore: firstRatedData?.score,
      memberDetailScore: ratedData,
      ratingComment: ratingComment,
    };
    setModalOpen(true);
    setModalData({
      staffInfo: ticketData,
      ratingsData: {
        ...params,
        tip:
          activeButton !== "no-tip"
            ? tipData?.productList[activeButton]
            : "no-tip",
        tipData,
      },
    });
  }

  async function submitRating() {
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      await httpPost({
        pathName: "rating",
        bodyParams: {
          ...modalData.ratingsData,
        },
      }).then((response: AxiosResponse<any>) => {
        var data = response.data;
        setPurchaseList(undefined);
        if (activeButton != "no-tip") {
          navigate(
            `/buy?productId=${tipData.productList[activeButton].productId}&parentTicketNumber=${ticketData?.ticketNumber}`,
            {
              state: {
                productId: tipData.productList[activeButton].productId,
                staffInfo: {
                  type: "tip",
                },
              },
            }
          );
        } else {
          navigate("/rating-complete", { state: { ratingCompleted: true } });
        }
        setAnalyticsData({ eventName: "ratingComplete" });
      });
    } catch (error) {
      if (Environment.getBuildType() != "prod") {
        console.log(error);
      }
      if (error.response.status >= 400 && error.response.status <= 499) {
        navigate(`/error?code=rating`);
      } else {
        navigate(`/error?code=${error.response?.status}`);
      }
    } finally {
      setLoading(false);
    }
  }
  return (
    <Fragment>
      {ticketData ? (
        <Box className="section bg-dots" component={"section"}>
          <Container className="container">
            <Box sx={{ textAlign: "center" }}>
              <SectionHeader currentPage={"評価のお願い"} preHeading={"Rate"} />
              <Typography
                component={"p"}
                className="mobile-text-left"
                style={{ maxWidth: "600px", margin: "0 auto" }}
              >
                今回の相談員の対応やサポート内容はいかがでしたでしょうか？
                <br />
                サービス向上のためにお客様からの評価のご協力をお願いしております。
              </Typography>
            </Box>
            <RatingTicket ticketDetails={ticketData} />
            <Grid
              container
              justifyContent="center"
              className="ratings-star-wrapper"
            >
              <Grid item md={10}>
                <Grid
                  container
                  className={`rating-stars first-rating ${
                    showAllRatings ? "show" : ""
                  }`}
                >
                  <Grid
                    item
                    md={3}
                    sm={"auto"}
                    xs={"auto"}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Typography
                      variant={"h6"}
                      style={{ display: "inline-block" }}
                    >
                      総合評価
                    </Typography>
                    <Typography className="required">必須</Typography>
                  </Grid>
                  <Grid item md={9} sm={12} xs={12}>
                    <RatingStars
                      initRating={0}
                      onRatingChanged={(newRating: any) => {
                        getFiveStarRating(newRating, "総合評価", "first");
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  className={`rest-ratings ${showAllRatings ? "show" : ""}`}
                >
                  {ratingList.map((rating, id) => (
                    <Grid
                      container
                      className="rating-stars"
                      key={id}
                      item
                      xs={12}
                    >
                      <Grid
                        item
                        md={3}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Typography variant={"h6"}>{rating.title}</Typography>
                        {rating.important && (
                          <Typography
                            style={{
                              backgroundColor: "#D63466",
                              borderRadius: "5px",
                              color: "#fff",
                              fontSize: "12px",
                              padding: "3px 5px",
                            }}
                          >
                            必須
                          </Typography>
                        )}
                      </Grid>
                      <Grid item md={9} sm={12} xs={12}>
                        <RatingStars
                          initRating={5}
                          onRatingChanged={(newRating: any) => {
                            getFiveStarRating(newRating, rating.title, "rest");
                          }}
                        />
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
            <ConcernTextArea
              heading={
                "【任意】 今回の相談員のサポート対応の感想を具体的に教えて下さい。"
              }
              subHeading={
                "こちらに具体的なサポート対応の感想をご記入ください。"
              }
              placeholder={""}
              concernText={ratingComment}
              setConcernText={setRatingComment}
              concernTextError={ratingTextError}
              setConcernTextError={setRatingTextError}
            />
            <Box style={{ marginTop: "40px" }}>
              <Box className="card-tooltip tooltip-accent">
                <Typography style={{ fontWeight: "900" }}>
                  相談員にチップを贈りますか？
                </Typography>
              </Box>
              <Grid container className="tip-wrapper">
                <Grid
                  item
                  md={"auto"}
                  className={
                    activeButton === "no-tip" ? "active no-tip" : "no-tip"
                  }
                  onClick={() => handleTip("no-tip")}
                >
                  <button style={{ fontWeight: "900" }}>贈らない</button>
                </Grid>
                {tipData &&
                  tipData.productList.map((tip, id) => (
                    <Grid
                      item
                      md={"auto"}
                      key={id}
                      className={
                        activeButton === id
                          ? `active tip-${tip.price}`
                          : `tip-${tip.price}`
                      }
                      onClick={() => handleTip(id)}
                    >
                      <button>
                        ¥<span>{tip.price}</span>
                      </button>
                    </Grid>
                  ))}
              </Grid>
            </Box>
            <Box
              style={{
                margin: "60px auto 0 ",
                textAlign: "center",
                maxWidth: "300px",
              }}
            >
              {loading && <div className="button-overlay"></div>}
              <button
                className="classification-btn"
                disabled={firstRatedData.length == 0 || loading}
                onClick={handleRatingSubmit}
              >
                {loading ? <ButtonLoader /> : "送信する"}
              </button>
            </Box>
          </Container>
          {ratingTextError && error && (
            <ErrorModal
              errorModal={errorModal}
              setErrorModal={setErrorModal}
              message={error}
            />
          )}
        </Box>
      ) : (
        <LoaderComponent />
      )}
      <RatingModal
        modal={modalOpen}
        modalData={modalData}
        onClose={() => {
          setModalOpen(false);
          setModalData(undefined);
        }}
        onSuccess={submitRating}
        loading={loading}
      />
    </Fragment>
  );
}
